export function getPeriodLength(periodId, fixtureProfile) {
  const getDefaultLength = () => {
    return periodId >= fixtureProfile.initialExtraPeriodId
      ? fixtureProfile.overtimeLength
      : fixtureProfile.periodLength;
  };

  if (periodId == null) {
    return fixtureProfile.periodLength;
  }

  if (!fixtureProfile.usePeriodLengthCustomized || !fixtureProfile.periodLengthCustomized) {
    return getDefaultLength();
  }

  const customPeriodLength = fixtureProfile.periodLengthCustomized[periodId];
  if (!customPeriodLength) {
    return getDefaultLength();
  }

  return customPeriodLength;
}
